module.exports = __webpack_public_path__ + "media/images/shared/icon_feature_white-e06e671ff1ef4d6a9e03e60946b6edf9.png";